import { type Breadcrumb, type ErrorEvent } from '@sentry/react';

// トークンだけで招待の受諾・登録やログインができるので、URL が画面の外へ送られる所では値を消す
const TOKEN_QUERY_PATTERN = /((?:^|[?&])(?:invitation_token|token)=)[^&#\s]*/gi;
// GA の通信の dl のように、URL の中へ URL エンコードして埋め込まれた ?token= も、fetch のパンくずとして Sentry に乗る
const ENCODED_TOKEN_QUERY_PATTERN =
  /((?:%3F|%26)(?:invitation_token|token)%3D)(?:(?!%26|%23)[^&#\s])*/gi;

export const maskTokenQuery = (value: string): string =>
  value
    .replace(TOKEN_QUERY_PATTERN, '$1[Filtered]')
    .replace(ENCODED_TOKEN_QUERY_PATTERN, '$1[Filtered]');

const maskStringValues = (
  record: Record<string, unknown>,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(record).map(([key, value]) => [
      key,
      typeof value === 'string' ? maskTokenQuery(value) : value,
    ]),
  );

export const maskTokenQueryInSentryBreadcrumb = (
  breadcrumb: Breadcrumb,
): Breadcrumb => ({
  ...breadcrumb,
  ...(breadcrumb.message && { message: maskTokenQuery(breadcrumb.message) }),
  ...(breadcrumb.data && { data: maskStringValues(breadcrumb.data) }),
});

export const maskTokenQueryInSentryEvent = (event: ErrorEvent): ErrorEvent => {
  const { request, breadcrumbs } = event;

  return {
    ...event,
    ...(request && {
      request: {
        ...request,
        ...(request.url && { url: maskTokenQuery(request.url) }),
        ...(typeof request.query_string === 'string' && {
          query_string: maskTokenQuery(request.query_string),
        }),
        ...(request.headers && {
          headers: maskStringValues(request.headers) as Record<string, string>,
        }),
      },
    }),
    ...(breadcrumbs && {
      breadcrumbs: breadcrumbs.map(maskTokenQueryInSentryBreadcrumb),
    }),
  };
};
